import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { SanityVideoEmbed } from "./SanityVideoEmbed";
export type SanityMediaFieldImage = {
  src: string;
  alt: string;
  width: number;
  height: number;
  /** CSS object-position (e.g. from a Sanity image hotspot). */
  objectPosition?: string;
};
export type SanityMediaFieldContentProps = {
  image?: SanityMediaFieldImage | null;
  videoUrl?: string | null;
  videoTitle?: string;
  className?: string;
  imageClassName?: string;
  videoClassName?: string;
  sizes?: string;
  /** @deprecated Prefer `preload` (Next.js 16). */
  priority?: boolean;
  preload?: boolean;
  loading?: "eager" | "lazy";
  fetchPriority?: "high" | "low" | "auto";
  /** When true (default), image uses Next.js `fill` layout. */
  fill?: boolean;
};

/**
 * Sync presentational renderer for a Sanity mediaField slot (image or video).
 * Safe for client components when image URLs are pre-resolved.
 */
export function SanityMediaFieldContent(t0) {
  const $ = _c(25);
  const {
    image,
    videoUrl,
    videoTitle: t1,
    className,
    imageClassName,
    videoClassName,
    sizes,
    priority,
    preload,
    loading,
    fetchPriority,
    fill: t2
  } = t0;
  const videoTitle = t1 === undefined ? "Embedded video" : t1;
  const fill = t2 === undefined ? true : t2;
  if (image) {
    const t3 = fill ? undefined : image.width;
    const t4 = fill ? undefined : image.height;
    let t5;
    if ($[0] !== image.objectPosition) {
      t5 = image.objectPosition ? {
        objectPosition: image.objectPosition
      } : undefined;
      $[0] = image.objectPosition;
      $[1] = t5;
    } else {
      t5 = $[1];
    }
    let t6;
    if ($[2] !== fetchPriority || $[3] !== fill || $[4] !== image.alt || $[5] !== image.src || $[6] !== imageClassName || $[7] !== loading || $[8] !== preload || $[9] !== priority || $[10] !== sizes || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
      t6 = <Image src={image.src} alt={image.alt} fill={fill} width={t3} height={t4} className={imageClassName} sizes={sizes} priority={priority} style={t5} preload={preload} loading={loading} fetchPriority={fetchPriority} />;
      $[2] = fetchPriority;
      $[3] = fill;
      $[4] = image.alt;
      $[5] = image.src;
      $[6] = imageClassName;
      $[7] = loading;
      $[8] = preload;
      $[9] = priority;
      $[10] = sizes;
      $[11] = t3;
      $[12] = t4;
      $[13] = t5;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    const imageElement = t6;
    let t7;
    if ($[15] !== className || $[16] !== imageElement) {
      t7 = className ? <div className={className}>{imageElement}</div> : imageElement;
      $[15] = className;
      $[16] = imageElement;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    return t7;
  }
  if (videoUrl) {
    let t3;
    if ($[18] !== videoClassName || $[19] !== videoTitle || $[20] !== videoUrl) {
      t3 = <SanityVideoEmbed videoUrl={videoUrl} title={videoTitle} className={videoClassName} />;
      $[18] = videoClassName;
      $[19] = videoTitle;
      $[20] = videoUrl;
      $[21] = t3;
    } else {
      t3 = $[21];
    }
    const videoElement = t3;
    let t4;
    if ($[22] !== className || $[23] !== videoElement) {
      t4 = className ? <div className={className}>{videoElement}</div> : videoElement;
      $[22] = className;
      $[23] = videoElement;
      $[24] = t4;
    } else {
      t4 = $[24];
    }
    return t4;
  }
  return null;
}